export default __webpack_public_path__ + "static/media/nomeacao.51f99269.png";